var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4606 5.985C17.5172 5.01375 14.9372 4.5 12 4.5C9.06281 4.5 6.48281 5.01375 4.53937 5.985C2.59594 6.95625 1.5 8.32312 1.5 9.75V14.25C1.5 15.6769 2.60812 17.0484 4.53937 18.015C6.47062 18.9816 9.06281 19.5 12 19.5C14.9372 19.5 17.5172 18.9862 19.4606 18.015C21.4041 17.0438 22.5 15.6769 22.5 14.25V9.75C22.5 8.32312 21.3919 6.95156 19.4606 5.985ZM12 6C17.8725 6 21 8.17781 21 9.75C21 11.3222 17.8725 13.5 12 13.5C6.1275 13.5 3 11.3222 3 9.75C3 8.17781 6.1275 6 12 6ZM11.25 14.9869V17.9869C9.46875 17.9288 7.96875 17.6662 6.75 17.2847V14.3484C8.21918 14.7399 9.72991 14.9542 11.25 14.9869ZM12.75 14.9869C14.2701 14.9542 15.7808 14.7399 17.25 14.3484V17.2838C16.0312 17.6653 14.5312 17.9278 12.75 17.9859V14.9869ZM3 14.25V12.5184C3.47205 12.9101 3.98876 13.2446 4.53937 13.515C4.76719 13.6284 5.00813 13.7353 5.25 13.8366V16.6875C3.76594 15.9525 3 15.0272 3 14.25ZM18.75 16.6875V13.8366C18.9947 13.7353 19.2328 13.6284 19.4606 13.515C20.0112 13.2446 20.5279 12.9101 21 12.5184V14.25C21 15.0272 20.2341 15.9525 18.75 16.6875Z",
    fill: "#FDA214"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhCoin);
export default __webpack_public_path__ + "static/media/ph_coin.9867b3530771d940c23449adb76fd4f8.svg";
export { ForwardRef as ReactComponent };